import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { SoftwareSpecificationApi, SystemSpecification } from 'icreate/common/models/system-specification';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SystemSpecificationService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getSystemSpecification(vesselId: string): Promise<SystemSpecification> {
        return await lastValueFrom(
            this.http.get<SystemSpecification>(`${this.domain}/api/system-specification`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async getSoftwareSpecification(vesselId: string): Promise<SoftwareSpecificationApi> {
        return await lastValueFrom(
            this.http.get<SoftwareSpecificationApi>(`${this.domain}/api/system-specification/software`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async getOthersSpecification(vesselId: string): Promise<SoftwareSpecificationApi> {
        return await lastValueFrom(
            this.http.get<SoftwareSpecificationApi>(`${this.domain}/api/system-specification/others`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async save(systemSpecification: SystemSpecification) {
        return await lastValueFrom(
            this.http.put<SoftwareSpecificationApi>(`${this.domain}/api/system-specification`, systemSpecification, {
                headers: this.headers,
            })
        );
    }
}
